import theme from 'config/theme';

export default {
  container: {
    width: '100%',
    borderRadius: 2,
    border: `1px solid ${theme.palette.grays.gray150}`,
    height: 'calc(100vh - 115px)',
    overflow: 'hidden',
  },
  paper: {
    width: 350,
    height: 'calc(100vh - 200px)',
    overflowY: 'auto',
    zIndex: 1,
    position: 'absolute',
    left: 14,
    top: 20,
    backgroundColor: 'white',
    borderRadius: 2,
  },
  sidebarHeader: {
    p: 2,
    borderBottom: 1,
    borderColor: 'divider',
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 2,
  },
  sidebarHeaderTitle: {
    p: 2,
    borderBottom: 1,
    borderColor: 'divider',
    position: 'sticky',
    opacity: 1,
    top: 0,
    zIndex: 2,
    backgroundColor: 'white !important',
  },
  sidebarListItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    py: 1.5,
    px: 2,
  },
  listItemContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    width: '100%',
    mb: 0.5,
  },
  listItemContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flex: 1,
  },
};
